'use strict';

Odigeo.defineWidget(
    'membership_timeout_popup',
    Odigeo.Widget.extend({
        viewClass: require('./view'),
        renderOF2Template: function() {
            this.view.setOF2Template();
        },
    })
);
